export default function getUserAge(dateString) {
  const today = new Date(app.forum.attribute("katerServerDate"));
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }
  return age;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/getUserAge', getUserAge);